// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import BrokenImage from '../_raw/ui/icon_broken_image.svg';
import withIconProps from '../withIconProps';

export default withIconProps(BrokenImage);
